import { render, staticRenderFns } from "./supplierNewsList.vue?vue&type=template&id=ccbc522e&scoped=true&"
import script from "./supplierNewsList.vue?vue&type=script&lang=js&"
export * from "./supplierNewsList.vue?vue&type=script&lang=js&"
import style0 from "./supplierNewsList.vue?vue&type=style&index=0&id=ccbc522e&scoped=true&lang=css&"
import style1 from "./supplierNewsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbc522e",
  null
  
)

export default component.exports